import { getExperiment } from "../config/experiments";
import { assignExperimentVariant, readExperimentOverride } from "./experimentAssignment";

export const SINGLE_EVENT_LAYOUT_VARIANTS = getExperiment("single_event_layout").variants.map(({ id }) => id);

export const getSingleEventLayoutOverride = (search) => readExperimentOverride({
  param: "layout",
  variants: SINGLE_EVENT_LAYOUT_VARIANTS,
  search,
});

/** ?layout=classic|express|cinematic|social|guide; ?layout=reset reassigns. */
export const assignSingleEventLayout = () => assignExperimentVariant({
  id: "single_event_layout",
  param: "layout",
  variants: SINGLE_EVENT_LAYOUT_VARIANTS,
});

// Runtime dates/access are resolved by the page, using its existing rules.
// Special flows retain the existing page and do not enter this experiment.
export const isSingleEventLayoutEligible = (event, {
  soldOutStatus = false,
  isPresale = false,
  isSignupExpired = false,
} = {}) => Boolean(
  event?.id
  && !event.app_only
  && !event.is_spin_win
  && !event.is_slot_machine
  && !event.exclusive_event
  && !event.sold_out
  && !soldOutStatus
  && !isPresale
  && !isSignupExpired
);
